module.exports = __webpack_public_path__ + "media/components/NarrowCallToAction/arrow-right-5ccb053de2c006f1de9d85368750084a.svg";